/**
 * Created by danielr on 6/16/15.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var AppKeyGalleryModel = {};

    var CONST = {
        DEFAULT_OPERATING_SYSTEM: 0
    };

    var OPERATING_SYSTEMS = {
        IOS: 0,
        ANDROID: 1,
        PROXY: 3,
    };

    var OPERATING_SYSTEMS_MAP = {};
    OPERATING_SYSTEMS_MAP[OPERATING_SYSTEMS.IOS] = "ios";
    OPERATING_SYSTEMS_MAP[OPERATING_SYSTEMS.ANDROID] = "android";
    OPERATING_SYSTEMS_MAP[OPERATING_SYSTEMS.PROXY] = "proxy";

    var KEYS = {
        APPLICATION_KEY: "applicationKey",
        DATE_CREATED: "dateCreated",
        NAME: "name",
        DESCRIPTION: "description",
        OPERATING_SYSTEM: "operatingSystem",
        CERTIFICATE: "certificate",
        CERTIFICATE_ID: "certificate.id",
        CERTIFICATE_FILE_NAME: "certificate.name",
        KEY: "key",
        KEY_ID: "key.id",
        KEY_FILE_NAME: "key.name"
    };


    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AppKeyGalleryModel = BaseModel.extend({
            idAttribute: "applicationKey",
            name: "AppKeyGalleryModel",
            defaults: {
                applicationKey: "",
                name:"",
                description: "",
                operatingSystem: CONST.DEFAULT_OPERATING_SYSTEM,
                certificate: {},
                key: {}
            },

            initialize: function (options) {
                BaseModel.prototype.initialize.call(this, options);
            },
            _getValue: function (key) {
                return this.get(key);
            },
            getDateCreated: function() {
                return this._getValue(KEYS.DATE_CREATED);
            },
            getAppKey: function () {
                return this._getValue(KEYS.APPLICATION_KEY);
            },
            getOperatingSystem: function () {
                return this._getValue(KEYS.OPERATING_SYSTEM);
            },
            getCertificateId: function(){
                return this._getValue(KEYS.CERTIFICATE_ID);
            },
            getCertificateFileName: function(){
                return this._getValue(KEYS.CERTIFICATE_FILE_NAME);
            },
            getKeyId: function(){
                return this._getValue(KEYS.KEY_ID);
            },
            getKeyFileName: function(){
                return this._getValue(KEYS.KEY_FILE_NAME);
            },
            isIos: function(){
                return this.getOperatingSystem() === OPERATING_SYSTEMS.IOS;
            },
            isAndroid: function(){
                return this.getOperatingSystem() === OPERATING_SYSTEMS.ANDROID;
            },
            isProxy: function(){
                return this.getOperatingSystem() === OPERATING_SYSTEMS.PROXY;
            },
            isCertificateSet: function(){
                return this.isIos() && !_.isUndefined(this.getCertificateId());
            },
            isKeySet: function(){
                return this.isIos() && !_.isUndefined(this.getKeyId());
            },
            hasMissingFile: function(){
                return (this.isIos() && !this.isCertificateSet() || !this.isKeySet());
            },
            getOperatingSystemName: function(){
                return OPERATING_SYSTEMS_MAP[this.getOperatingSystem()];
            },

            isEditable: function(){
                return true;
            },
            isViewable: function(){
                return true;
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    AppKeyGalleryModel.KEYS = KEYS;
    return AppKeyGalleryModel;
});

